import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";

import { useRecordBrandNameClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordBrandNameClickEvent";
import { useRecordChooseOptionClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordChooseOptionClickEvent";
import { useRecordChooseOptionQuantityUpdateSubmitEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordChooseOptionQuantityUpdateSubmitEvent";
import { useRecordHeartClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordHeartClickEvent";
import { useRecordProductBadgeViewEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordProductBadgeViewEvent";
import { useRecordProductTileClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordProductTileClickEvent";
import { useRecordProductTileRightClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordProductTileRightClickEvent";
import { useRecordQuickAddButtonClickEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordQuickAddButtonClickEvent";
import { useRecordQuickAddSubmitEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordQuickAddSubmitEvent";
import { useRecordRemoveFromBoardSubmitEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordRemoveFromBoardSubmitEvent";
import { useRecordSaveToBoardSubmitEvent } from "@faire/retailer/hooks/ProductTileImpression/__internal__/events/useRecordSaveToBoardSubmitEvent";

export const useProductTileClickImpressions = (
  productTile: ILeanProductTile = ILeanProductTile.build({}),
  brand: ILeanProductTile.IBrand = ILeanProductTile.IBrand.build({}),
  recordImpressions = false
) => {
  /**
   * All tracking events added here MUST be no-op
   */
  const recordProductTileClickEvent = useRecordProductTileClickEvent(
    productTile,
    recordImpressions
  );
  const recordBrandNameClickEvent = useRecordBrandNameClickEvent(
    productTile,
    brand,
    recordImpressions
  );
  const recordProductTileRightClickEvent = useRecordProductTileRightClickEvent(
    productTile,
    recordImpressions
  );
  const recordProductBadgeViewEvent = useRecordProductBadgeViewEvent(
    productTile,
    recordImpressions
  );

  // Board Events
  const recordHeartClickedEvent = useRecordHeartClickEvent(
    productTile,
    recordImpressions
  );
  const recordSaveToBoardSubmitEvent = useRecordSaveToBoardSubmitEvent(
    productTile,
    recordImpressions
  );
  const recordRemoveFromBoardSubmitEvent = useRecordRemoveFromBoardSubmitEvent(
    productTile,
    recordImpressions
  );

  // QuickAdd Events
  const recordQuickAddButtonClickEvent = useRecordQuickAddButtonClickEvent(
    productTile,
    recordImpressions
  );
  const recordQuickAddSubmitEvent = useRecordQuickAddSubmitEvent(
    productTile,
    recordImpressions
  );
  const recordChooseOptionClickEvent = useRecordChooseOptionClickEvent(
    productTile,
    recordImpressions
  );
  const recordChooseOptionQuantityUpdateSubmitEvent =
    useRecordChooseOptionQuantityUpdateSubmitEvent(
      productTile,
      recordImpressions
    );

  return {
    recordProductTileClickEvent,
    recordBrandNameClickEvent,
    recordProductTileRightClickEvent,
    recordProductBadgeViewEvent,
    recordHeartClickedEvent,
    recordSaveToBoardSubmitEvent,
    recordRemoveFromBoardSubmitEvent,
    recordQuickAddButtonClickEvent,
    recordQuickAddSubmitEvent,
    recordChooseOptionClickEvent,
    recordChooseOptionQuantityUpdateSubmitEvent,
  };
};
